import * as $ from 'jquery';
import {NgZone} from '@angular/core';
import {PopupService} from '../../popup-component/popup.service/popup.service';

export class OldDetailsScript {

  constructor(private readonly popupService: PopupService) {
  }

  onInitOnlineKeysView() {
    const self = this;
    setTimeout(() => {
        $(document).on('click', '#search', online_keys_submit_search);

        const nestedForm = $('#nestedform').find('input');
        $(document).on('keydown', nestedForm, online_keys_keypressed);
        $(document).on('mouseup', '#searchtext', online_keys_clear_button);
        $(document).on('click', '#onlinekeypassen.detailTable tr a', function(event) {
          event.preventDefault();
          $(this).closest('tr').addClass('selected').siblings().removeClass('selected');
          const arrangementNo = $(this).closest('tr').find('[id*=\'pasovknr\']').html();
          const productServiceUrl = $(this).closest('tr').find('input').attr('value');
          self.ajaxCallForDetails(arrangementNo, productServiceUrl, self);
        });

        function online_keys_clear_button() {
          // When this event is fired after clicking on the clear button
          // the value is not cleared yet. We have to wait for it.
          const input = $(this);

          setTimeout(() => {
            const newValue = input.val();

            if (newValue === '') {
              online_keys_clear_search();
            }
          }, 1);
        }

        function online_keys_monitor_search(search_box) {
          if ($(search_box).val() === '') {
            online_keys_clear_search();
          }
          return true;
        }

        function online_keys_clear_search() {
          $('#searchtext').val('');

          $('tbody tr[id^="onlinekeypassen.row"]').each(function() {
            $(this).show();
          });

          return true;
        }

        function online_keys_submit_search(event) {
          event.preventDefault();

          const value = $('#searchtext').val();
          const searchString = ('' + value).toLowerCase();
          $('tbody tr[id^="onlinekeypassen.row"]').each(function() {
            $(this).hide();
            online_keys_select_rokpas('td:nth-child(6)', this, searchString);
            online_keys_select_rokpas('td:nth-child(7)', this, searchString);
            online_keys_select_rokpas('td:nth-child(8)', this, searchString);
            online_keys_select_rokpas('td:nth-child(9)', this, searchString);
            online_keys_select_rokpas('td:nth-child(10)', this, searchString);
            online_keys_select_rokpas('td:nth-child(11)', this, searchString);
            online_keys_select_rokpas('td:nth-child(12)', this, searchString);
            online_keys_select_rokpas('td:nth-child(13)', this, searchString);
          });
          return;
        }

        function online_keys_select_rokpas(selector, node, searchString) {
            const text = ($(selector, node) as any).text().toLowerCase();
            if (text) {
              if ((text.indexOf(searchString) !== -1) || ((text.replace(/ /g, '') + ' ').indexOf(searchString) !== -1)) {
                $(node).show();
              }
            }
            return false;
        }

        function online_keys_keypressed(event) {
          const charcode = (event.which) ? event.which : (window.event as any).keyCode;
          if (charcode === 13) {
            return online_keys_submit_search(event);
          } else if (charcode === 27) {
            return online_keys_clear_search();
          }
          return true;
        }

      }, 1000);
  }

  ajaxCallForDetails(arrangementNo, productServiceUrl, thisClass) {
  }

  initProductServicePopUpInteraction(_requiredData) {
    const requiredData = _requiredData || {};
    $('#productServicePopUpButton').click(() => {
      this.popupService.openPopup('productservices', requiredData);
    });
  }

  initBetalenBinnenlandView() {
      setTimeout(() => {

        const columnOffset = 4;
        const showColumns = 6;
        const scrollStep = 6;
        let startIndex = 0;
        const el = $('table.detailTable th:nth-child(3)');
        const totaalAantalRekeningenText = el.html();
        const splitText = totaalAantalRekeningenText.split(' (');
        const totaalAantalRekeningenArray = splitText[1].split(' ') as unknown;
        const totaalAantalRekeningenArrayAsString = totaalAantalRekeningenArray as string;
        const totaalAantalRekeningenAsUnknown = totaalAantalRekeningenArrayAsString[0] as unknown;
        const totaalAantalRekeningenAsNumber = totaalAantalRekeningenAsUnknown as number;
        const endIndex = columnOffset + totaalAantalRekeningenAsNumber as number;

        scrollH();

        $(document).on('click', 'input[id="previousColumns"]', () => {
          // set the startIndex
          if ((startIndex) <= 0) {
            return; // cannot go back
          }
          for (let i = scrollStep; i > 0; i--) {
            startIndex = startIndex - 1;
            if ((startIndex) === 0) {
              break;
            }
          }
          scrollH();
        });

        $(document).on('click', 'input[id="nextColumns"]', () => {
          // set the startIndex
          if ((startIndex + columnOffset + showColumns) >= endIndex) {
            return; // cannot go forward
          }
          for (let i = 0; i < scrollStep; i++) {
            startIndex = startIndex + 1;
            if ((startIndex + columnOffset + showColumns) === endIndex) {
              break;
            }
          }
          scrollH();
        });

        function scrollH() {
          // show the label columns
          $('table.detailTable th:nth-child(n+' + (columnOffset) + ')').show();
          // hide te columns between the label columns and the startIndex
          $('table.detailTable th:nth-child(n+' + (columnOffset) + '):nth-child(-n+' + (columnOffset + startIndex) + ')').hide();
          // show the columns from column offset and showColumns
          $('table.detailTable th:nth-child(n+' + (columnOffset + startIndex) + '):nth-child(-n+' + (columnOffset + startIndex + showColumns) + ')').show();
          // hide the columns at the end if there any
          $('table.detailTable th:nth-child(n+' + (columnOffset + startIndex + showColumns) + '):nth-child(-n+' + (endIndex) + ')').hide();

          // scroll data columns
          $('table.detailTable td:nth-child(n+' + (columnOffset) + ')').show();
          // hide te columns between the label collumns and the startIndex
          $('table.detailTable td:nth-child(n+' + (columnOffset) + '):nth-child(-n+' + (columnOffset + startIndex) + ')').hide();
          // show the columns from column offset and showColumns
          $('table.detailTable td:nth-child(n+' + (columnOffset + startIndex) + '):nth-child(-n+' + (columnOffset + startIndex + showColumns) + ')').show();
          // hide the columns at the end if there any
          $('table.detailTable td:nth-child(n+' + (columnOffset + startIndex + showColumns) + '):nth-child(-n+' + (endIndex) + ')').hide();
        }

      }, 1000);
  }

  initDynamicTableDetailsView(numberOfShownColumns: number) {
    setTimeout(() => {
      const cnum = getColumnCount('table.detailTable#scrollTable > thead > tr:first > th');
      const columnOffsetHeader = 3; // extra dummy column to make it work.
      const columnOffsetData = 3;
      const showColumnsHeader = numberOfShownColumns;
      const showColumnsData = showColumnsHeader;
      const scrollStepHeader = showColumnsHeader;
      const scrollStepData = showColumnsHeader;
      const startIndexHeader = 0;
      const startIndexData = 0;
      const endIndexHeader = cnum;
      const endIndexData = cnum;

      scrollH();

      function scrollH() {
        $('input[id="nextColumns"]').removeAttr('disabled');
        $('input[id="previousColumns"]').removeAttr('disabled');
        // show the label columns
        $('table.detailTable#scrollTable th:nth-child(n+' + (columnOffsetHeader) + ')').show();
        // hide te columns between the label collumns and the startIndex
        $('table.detailTable#scrollTable th:nth-child(n+' + (columnOffsetHeader) + '):nth-child(-n+' + (columnOffsetHeader + startIndexHeader) + ')').hide();
        // show the columns from column offset and showColumns
        $('table.detailTable#scrollTable th:nth-child(n+' + (columnOffsetHeader + startIndexHeader) + '):nth-child(-n+' + (columnOffsetHeader + startIndexHeader + showColumnsHeader) + ')').show();
        // hide the columns at the end if there any
        $('table.detailTable#scrollTable th:nth-child(n+' + (columnOffsetHeader + startIndexHeader + showColumnsHeader) + '):nth-child(-n+' + (endIndexHeader) + ')').hide();

        // scroll data columns
        $('table.detailTable#scrollTable td:nth-child(n+' + (columnOffsetData) + ')').show();
        // hide te columns between the label collumns and the startIndex
        $('table.detailTable#scrollTable td:nth-child(n+' + (columnOffsetData) + '):nth-child(-n+' + (columnOffsetData + (startIndexData)) + ')').hide();
        // show the columns from column offset and showColumns
        $('table.detailTable#scrollTable td:nth-child(n+' + (columnOffsetData + (startIndexData)) + '):nth-child(-n+' + (columnOffsetData + (startIndexData) + (showColumnsData)) + ')').show();
        // hide the columns at the end if there any
        $('table.detailTable#scrollTable td:nth-child(n+' + (columnOffsetData + (startIndexData) + (showColumnsData)) + '):nth-child(-n+' + (endIndexData) + ')').hide();

        if ((startIndexHeader + columnOffsetHeader + showColumnsHeader) >= endIndexHeader) {
          $('input[id="nextColumns"]').attr('disabled', 'disabled');
        }
        if ((startIndexData + columnOffsetData + showColumnsData) >= endIndexData) {
          $('input[id="nextColumns"]').attr('disabled', 'disabled');
        }
        if ((startIndexHeader) <= 0) {
          $('input[id="previousColumns"]').attr('disabled', 'disabled');
        }
        if ((startIndexData) <= 0) {
          $('input[id="previousColumns"]').attr('disabled', 'disabled');
        }

      }

      function getColumnCount(headerRowId) {
        let columnCount = 1; // extra dummy column need to be fixed.
        $(headerRowId).each(function() {
          const colspanValue = $(this).attr('colspan');
          if (colspanValue === undefined) {
            columnCount++;
          } else {
            columnCount = columnCount + parseInt(colspanValue);
          }
        });
        return columnCount;
      }

    }, 1000);
  }

  initRekeningCourantCluserDetailsView() {
      setTimeout(() => {

        const columnOffsetHeader = 5;
        const columnOffsetData = 5;
        const showColumnsHeader = 5;
        const showColumnsData = 10;
        const scrollStepHeader = 5;
        const scrollStepData = 10;
        let startIndexHeader = 0;
        let startIndexData = 0;
        const el = $('table.detailTable th:nth-child(4)');
        const totaalAantalRekeningenText = el.html() as string;
        const splitText = totaalAantalRekeningenText.split(' (');
        const totaalAantalRekeningenArray = splitText[1].split(' ') as unknown;
        const totaalAantalRekeningenArrayAsString = totaalAantalRekeningenArray as string;
        const totaalAantalRekeningenAsUnknown = totaalAantalRekeningenArrayAsString[0] as unknown;
        const totaalAantalRekeningenAsNumber = totaalAantalRekeningenAsUnknown as number;
        const endIndexHeader = columnOffsetHeader + totaalAantalRekeningenAsNumber;
        const endIndexData = columnOffsetData + totaalAantalRekeningenAsNumber * 2;

        scrollH();
        $('input[id="previousColumns"]').hide();

        $(document).on('click', 'input[id="previousColumns"]', () => {
          // set the startIndex
          for (let i = scrollStepHeader; i > 0; i--) {
            startIndexHeader = startIndexHeader - 1;
            if ((startIndexHeader) === 0) {
              break;
            }
          }
          for (let i = scrollStepData; i > 0; i--) {
            startIndexData = startIndexData - 1;
            if ((startIndexData) === 0) {
              break;
            }
          }
          $('input[id="nextColumns"]').show();
          scrollH();
        });

        $(document).on('click', 'input[id="nextColumns"]', () => {

          for (let i = 0; i < scrollStepHeader; i++) {
            startIndexHeader = startIndexHeader + 1;
            if ((startIndexHeader + columnOffsetHeader + showColumnsHeader) === endIndexHeader) {
              break;
            }
          }
          for (let i = 0; i < scrollStepData; i++) {
            startIndexData = startIndexData + 1;
            if ((startIndexData + columnOffsetData + showColumnsData) === endIndexData) {
              break;
            }
          }
          $('input[id="previousColumns"]').show();
          scrollH();
        });

        function scrollH() {
          // show the label columns
          $('table.detailTable th:nth-child(n+' + (columnOffsetHeader) + ')').show();
          // hide te columns between the label columns and the startIndex
          $('table.detailTable th:nth-child(n+' + (columnOffsetHeader) + '):nth-child(-n+' + (columnOffsetHeader + startIndexHeader) + ')').hide();
          // show the columns from column offset and showColumns
          $('table.detailTable th:nth-child(n+' + (columnOffsetHeader + startIndexHeader) + '):nth-child(-n+' + (columnOffsetHeader + startIndexHeader + showColumnsHeader) + ')').show();
          // hide the columns at the end if there any
          $('table.detailTable th:nth-child(n+' + (columnOffsetHeader + startIndexHeader + showColumnsHeader) + '):nth-child(-n+' + (endIndexHeader) + ')').hide();

          // scroll data columns
          $('table.detailTable td:nth-child(n+' + (columnOffsetData) + ')').show();
          // hide te columns between the label collumns and the startIndex
          $('table.detailTable td:nth-child(n+' + (columnOffsetData) + '):nth-child(-n+' + (columnOffsetData + (startIndexData)) + ')').hide();
          // show the columns from column offset and showColumns
          $('table.detailTable td:nth-child(n+' + (columnOffsetData + (startIndexData)) + '):nth-child(-n+' + (columnOffsetData + (startIndexData) + (showColumnsData)) + ')').show();
          // hide the columns at the end if there any
          $('table.detailTable td:nth-child(n+' + (columnOffsetData + (startIndexData) + (showColumnsData)) + '):nth-child(-n+' + (endIndexData) + ')').hide();
          // set the startIndex
          if ((startIndexHeader + columnOffsetHeader + showColumnsHeader) >= endIndexHeader) {
            $('input[id="nextColumns"]').hide();
            // return; // cannot go foreward
          }
          if ((startIndexData + columnOffsetData + showColumnsData) >= endIndexData) {
            $('input[id="nextColumns"]').hide();
            // return; // cannot go foreward
          }
          if ((startIndexHeader) <= 0) {
            $('input[id="previousColumns"]').hide();
            // return; //cannot go back
          }
          if ((startIndexData) <= 0) {
            $('input[id="previousColumns"]').hide();
            // return; //cannot go back
          }

        }
      }, 1000);

  }

}
